export default class ScrollAnime {
    constructor() {
        this._init();
    }

    _init() {
        this._setToggleClassOnce();
    }

    _setToggleClassOnce() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    entry.target.classList.add("-viewed");
                    observer.unobserve(entry.target);
                }
            });
        });

        [...document.querySelectorAll(".js-scroll-class")].forEach(($target) => {
            observer.observe($target);
        });
    }
}
